import { Field, Formik } from "formik";
import { useState } from "react";
import { Alert, Button, Card, Col, Form, Row } from "react-bootstrap"
import * as Yup from 'yup';
import Get from "../api/Get";
import { PAYMENT_APPOINTMENT_CONEKTA } from "../api/Routes";
import LoadingList from "../loader/LoadingList";
import moment from 'moment'
import { withTranslation } from "react-i18next";

function CardCredit({t, id, access_token, setShowSuccess, history}){
    const [payment, setPayment] = useState(false)
    const [errorPayment, setErrorPayment] = useState(false)
    const [message, setMessage] = useState('')


    const cardNumberRegExp = /^(^4[0-9]{12}(?:[0-9]{3})?$)|(^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$)|(3[47][0-9]{13})|(^3(?:0[0-5]|[68][0-9])[0-9]{11}$)|(^6(?:011|5[0-9]{2})[0-9]{12}$)|(^(?:2131|1800|35\d{3})\d{11}$)$/
    const cvvRegExp = /^([0-9]{3})$/
    const meses = [
        {key:"01", name:t('enero')},{key:"02", name:t('febrero')},{key:"03", name:t('marzo')},{key:"04", name:t('abril')},{key:"05", name:t('mayo')},
        {key:"06", name:t('junio')},{key:"07", name:t('julio')},{key:"08", name:t('agosto')},{key:"09", name:t('septiembre')},
        {key:"10", name:t('octubre')},{key:"11", name:t('noviembre')},{key:"12", name:t('diciembre')}
    ]
    const rangeOfYears = (start, end) => Array(end - start + 1)
                        .fill(start)
                        .map((year, index) => year + index)
    const years = rangeOfYears(moment().year(), moment().add(8, 'years').year())


    const shema = Yup.object().shape({
        cardNumber: Yup.string()
            .matches(cardNumberRegExp, t('campo_no_valido')) 
            .required(t('Camporequerido')),
        cardMes: Yup.string() 
            .required(t('Camporequerido')),
        cardYear: Yup.string() 
            .required(t('Camporequerido')),
        cvv: Yup.string() 
            .matches(cvvRegExp, t('campo_no_valido')) 
            .required(t('Camporequerido')),
        cardHolder: Yup.string() 
            .required(t('Camporequerido')),
    });

    const successResponseHandler = function(token) {
        //ENVIAMOS LA PETICION AL SERVER
        Get({url: `${PAYMENT_APPOINTMENT_CONEKTA}/${token.id}/${id}`, access_token: access_token})
        .then(response=>{
            setPayment(false)
            if(response.data.status==="Error"){
                setErrorPayment(true)
                setMessage(response.data.message)
            }else{
                setErrorPayment(false)
                setMessage('')
                setShowSuccess(true)
                setTimeout(() => {
                    setShowSuccess(false)
                    history.replace("/admin")
                }, 2000);
            }
            
            
        })
        .catch(error=>{
            console.log(error)
            setPayment(false)
            setErrorPayment(true)
            setMessage(t('pago_no_procesado'))
        })
    };
    const errorResponseHandler = function(error) {
        console.log('error')
        console.log(error)
        setPayment(false)
        setErrorPayment(true)
        setMessage(error.message_to_purchaser)
    };
    
    return (
        <Formik
            initialValues={{
                cardNumber: "",
                cardHolder: "",
                cardMes: "01",
                cardYear: moment().year(),
                cvv: ""
            }}
            validationSchema={shema}
            onSubmit={(values, { setSubmitting,setFieldValue }) => { 
                //console.log(values)
                setPayment(true)
                setErrorPayment(false)
                setMessage('')
                let tokenParams = {
                    "card": {
                        "number": values.cardNumber,
                        "name": values.cardHolder,
                        "exp_year": values.cardYear,
                        "exp_month": values.cardMes,
                        "cvc": values.cvv,
                      }
                }
                //console.log(tokenParams)                
                window.Conekta.setPublicKey("key_Bsx4i6NvMHs1zfNzHsVJCZw")
                window.Conekta.Token.create(tokenParams, successResponseHandler, errorResponseHandler);
            }}
        >{({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue
        }) => (
            <Form onSubmit={handleSubmit}>
                {payment && <LoadingList texto={t('procesando_pago')}/>}
                <Card>
                    <Card.Body>
                        {
                            errorPayment && 
                            <Row>
                                <Col>
                                    <Alert variant="danger">{message}</Alert>
                                </Col>
                            </Row>
                        }
                        <Row>
                            <Col xs="12" md="12" className="mb-2">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('no_tarjeta')} <span className="text-danger">*</span></Form.Label>
                                    <Field 
                                        type="text"
                                        className={`form-control input-form ${errors.cardNumber && 'error'}`}
                                        name="cardNumber"
                                        placeholder="****************"
                                    />
                                    { errors.cardNumber && <div className="invalid-feedback d-block">{errors.cardNumber}</div> }
                                </Form.Group>                                
                            </Col>
                            <Col xs="6" md="4" className="mb-2">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('mes')} <span className="text-danger">*</span></Form.Label>
                                    <Field 
                                        as="select"
                                        className={`form-control input-form ${errors.cardMes && 'error'}`}
                                        name="cardMes"
                                    >
                                        {
                                            meses.map((item, i)=>(
                                                <option key={i} value={item.key}>{`${item.key} - ${item.name}`}</option>
                                            ))
                                        }
                                    </Field>
                                    { errors.cardMes && <div className="invalid-feedback d-block">{errors.cardMes}</div> }
                                </Form.Group>                                
                            </Col>
                            <Col xs="6" md="4" className="mb-2">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('anio')} <span className="text-danger">*</span></Form.Label>
                                    <Field 
                                        as="select"
                                        className={`form-control input-form ${errors.cardYear && 'error'}`}
                                        name="cardYear"
                                    >                                        
                                        {
                                            years.map((item)=>(
                                                <option key={item} value={item}>{item}</option>
                                            ))
                                        }
                                    </Field>
                                    { errors.cardYear && <div className="invalid-feedback d-block">{errors.cardYear}</div> }
                                </Form.Group>                                
                            </Col>
                            <Col xs="6" md="4" className="mb-2">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">CVV <span className="text-danger">*</span></Form.Label>
                                    <Field 
                                        type="text"
                                        className={`form-control input-form ${errors.cvv && 'error'}`}
                                        name="cvv"
                                        placeholder="CVV"
                                    />
                                    { errors.cvv && <div className="invalid-feedback d-block">{errors.cvv}</div> }
                                </Form.Group>                                
                            </Col>
                            <Col xs="12" md="12">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">{t('nombre_tarjeta')} <span className="text-danger">*</span></Form.Label>
                                    <Field 
                                        type="text"
                                        className={`form-control input-form ${errors.cardHolder && 'error'}`}
                                        name="cardHolder"
                                    />
                                    { errors.cardHolder && <div className="invalid-feedback d-block">{errors.cardHolder}</div> }
                                </Form.Group>                                
                            </Col>
                        </Row> 
                    </Card.Body>
                </Card>


                <Row className="justify-content-center my-3">
                    <Col className="text-center text-md-right">
                        <Button className="ok-buttom" variant="outline-success" type="submit">{t('pagar')}</Button>
                    </Col>
                </Row>
            </Form>          
        )}
        </Formik>    
        
    )
}
export default withTranslation()(CardCredit)